import { useContents, useLocalizations, useTenant } from '@/core';
import { postGql } from '@/core/services/graphql';

const { setLocalization } = useLocalizations();
const { tenant } = useTenant();
const { setObject } = useContents();

const queryContentWithLocale = `query queryContentWithLocale($objectId: String!, $locale: String!) {
  content(objectId: $objectId) {
    data {
      id
      namespace
      content
      localization(locale: $locale)
    }
    error {
      message
      status
    }
  }
}`;

const fetchObject = async (contentId, language = 'nn'): Promise<void> => {
  if (contentId) {
    const gqlRes = await postGql(tenant.value.namespace, {
      query: queryContentWithLocale,
      variables: {
        objectId: contentId,
        locale: language,
      },
    });

    setObject([gqlRes.data.content.data]);

    if (gqlRes.data.content.data.localization) {
      gqlRes.data.content.data.localization.objectId = contentId;
      setLocalization({
        objectId: contentId,
        locale: language,
        service: 'edtech.content',
        content: gqlRes.data.content.data.localization,
      });
    }
  }
};

export default () => ({
  fetchObject,
});
